import axios from 'axios'
import React from 'react'

import HomeText from './text/home-text'

export default class InviteForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      firstName: null,
      lastName: null,
      email: null,
      status: null
    }
  }

  setInput = ev => {
    this.setState({
      [ev.target.dataset.type]: ev.target.value
    })
  }

  subscribeUser = () => {
    let { firstName, lastName, email } = this.state
    // TO DO: Would be nice to have some checking at this stage to prevent api
    // request

    axios.post('/signup', {
      firstName,
      lastName,
      email
    })
    .then(({ data }) => {
      console.log(data, data.status)
      let status = data.status === 'success'
      this.setState({
        status: status ? 'Thanks for signing up!' : data.text
      })
    })

  }

  renderForm = () => (
    <div>
      <div className="small-text">{HomeText[11]}</div>
      <input className="home-input"
        data-type="firstName"
        onChange={this.setInput}
        placeholder="First Name" />
      <input className="home-input"
        data-type="lastName"
        onChange={this.setInput}
        placeholder="Last Name" />
      <input className="home-input"
        data-type="email"
        onChange={this.setInput}
        placeholder="E-mail Address" />
      <div className="subscribe center"
        onClick={this.subscribeUser}>
        {this.props.isInvitePage ? 'GET INVITE' : 'SUBSCRIBE'}
      </div>
    </div>
  )

  renderStatus = () => (
    <div className="signup-status medium-text">
      {this.state.status}
    </div>
  )

  render() {
    return (
      <div className="home-form">
        {this.state.status ? this.renderStatus() : this.renderForm()}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/InviteForm.js